import { render } from "./DetailTopNav.vue?vue&type=template&id=634d8541"
import script from "./DetailTopNav.vue?vue&type=script&lang=js"
export * from "./DetailTopNav.vue?vue&type=script&lang=js"

import exportComponent from "F:\\PWAs\\amara-pwa\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__